import axiosInstance from './axiosInstance';

const getLimits = ({ userId, kriptoService, currency }) =>
  axiosInstance.get('/internal/admin/config/limit', {
    params: { user_id: userId, kripto_service: kriptoService, currency },
  });

export default getLimits;
